import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Outlet } from "@tanstack/react-router"

import { AppShell } from "@/components/layout/app-shell"
import { MainSidebar } from "@/components/layout/main-sidebar"
import { IssueProperties } from "@/features/issues/components/issue-properties"
import { issueQueries } from "@/queries/issues"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/issues/$issueId"
)({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(issueQueries.detail(params.issueId)),
  component: IssueWorkspaceLayout,
})

function IssueWorkspaceLayout() {
  const { issueId } = Route.useParams()
  const { data: issue } = useSuspenseQuery(issueQueries.detail(issueId))

  return (
    <AppShell
      sidebar={<MainSidebar />}
      aside={<IssueProperties issue={issue} />}
    >
      <Outlet />
    </AppShell>
  )
}
